import { type IconName, Modal } from '@dev-spendesk/grapes';

export const CommonModal = ({
  isOpen,
  children,
  iconName,
  subtitle,
  title,
  onClose,
}: {
  isOpen: boolean;
  children: React.ReactNode;
  title: string;
  iconName: IconName;
  subtitle?: string;
  onClose: () => void;
}) => {
  return (
    <Modal
      isOpen={isOpen}
      iconName={iconName}
      subtitle={subtitle}
      iconVariant="purple"
      title={title}
      actions={[]}
      onClose={onClose}
    >
      <div className="mb-32 mt-24 flex flex-col gap-16 text-left">
        {children}
      </div>
    </Modal>
  );
};
